import * as actions from "../../actions/actions";

const initialState = {
    fileHistory: null,
    error: null,
}

export default function fileHistory(state = initialState, action) {
    switch (action.type) {
        case actions.FETCH_FILE_HISTORY_SUCCESS:
            return fetchFileHistorySuccess(state, action)
        case actions.FETCH_FILE_HISTORY_FAILURE:
            return fetchFileHistoryFailure(state, action)
        default:
            return state
    }
}

const fetchFileHistorySuccess = (state, action) => {
    return {
        ...state,
        error: null,
        fileHistory: action.history
    }
}

const fetchFileHistoryFailure = (state, action) => {
    return {
        ...state,
        error: action.error,
        files: null
    }
}